module.exports = __webpack_public_path__ + "static/AskWithdraw-0cb93b56f1daca131a699e368f383a6f.png";